import { Navigation, Pagination, Autoplay, EffectFade, Mousewheel } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';
import { AnimatePresence, motion } from "framer-motion";
import { useRouter } from "next/router";
import { useContext, useState } from "react";
import { isMobileContext } from "../../contexts/isMobileContext";
import TestimonialsCard from "./TestimonialsCard";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useTranslation } from "next-i18next";
import FadeIn from "../Animations/FadeIn";
import Magnitizer from "../Animations/Magnitizer";
const Testimonials = ({ testimonialsData }) => {
    const { locale } = useRouter()
    const { isMobile } = useContext(isMobileContext);
    const [slideNumber, setSlideNumber] = useState('0' + 1);
    const { t } = useTranslation('common')
    return (
        <div className="testimonials-section">
            {testimonialsData?.Our_Testimonials?.length > 1 && <motion.div
                initial={{ opacity: "0", }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ delay: .4, duration: .75 }}
                className={`progress`}>
                <CircularProgressbar
                    styles={buildStyles({ pathColor: '#31353d' })}
                    value={slideNumber} minValue="0" strokeWidth={1} counterClockwise={locale == "ar" ? false : true} maxValue={testimonialsData?.Our_Testimonials?.length} />
            </motion.div>}
            <FadeIn customClass="header light">
                <h3 className="title _eleX">{testimonialsData?.Header}</h3>
            </FadeIn>
            <Swiper
                key={testimonialsData?.Our_Testimonials?.length}
                style={{ direction: locale == "ar" ? "rtl" : "ltr" }}
                modules={[
                    Navigation,
                    Pagination,
                    EffectFade,
                    Mousewheel,
                ]}

                navigation={{
                    nextEl: ".swiper-button-next-test",
                    prevEl: ".swiper-button-prev-test",
                }}
                className="swiper-test-section"
                slidesPerView={1}
                onSlideChange={(swiper) => { setSlideNumber('0' + (swiper.realIndex + 1)) }}
                spaceBetween={20}
                breakpoints={{
                    768: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                    1024: {
                        slidesPerView: 1,
                        spaceBetween: 50,
                    },
                }}
                fadeEffect={{
                    crossFade: true
                }}
                effect="fade"
                pagination={{
                    type: "progressbar",
                    el: ".swiper-testimonials-navigation",
                }}
            // loop={true}
            >
                {testimonialsData?.Our_Testimonials?.map((data, index) => (
                    <SwiperSlide key={index}>
                        {({ isActive }) => (
                            <TestimonialsCard cardData={data} index={index} isActive={isActive} slideNumber={slideNumber} length={testimonialsData?.Our_Testimonials?.length} />
                        )}
                    </SwiperSlide>
                ))}
            </Swiper>
            <div className={`swiper-navigation-continer ${testimonialsData?.Our_Testimonials?.length == 1 && "d-none"}`}>
                <div className="navigation-container">
                    <div className="slide-number-container bold">
                        <div>{slideNumber}</div>
                        <div>{"0" + testimonialsData?.Our_Testimonials?.length}</div>
                    </div>
                    <div className="swiper-testimonials-navigation swiper-pagination-progressbar"></div>
                </div>
                <div className={`arrows-container`}>
                    <Magnitizer dataDest={1.5}>
                        <div className=" swiper-button-prev swiper-button-prev-test test-arrow black-arrow-prev"
                        ></div>
                    </Magnitizer>
                    <Magnitizer dataDest={1.5}>
                        <div className=" swiper-button-next swiper-button-next-test  test-arrow black-arrow-next"
                        ></div>
                    </Magnitizer>
                </div>
            </div>
        </div >
    )
}

export default Testimonials

